export default "__VITE_PUBLIC_ASSET__435b9ac5__"